import {schema as Schema} from 'normalizr';

export const paperAssessmentListEntity = new Schema.Entity('items', {}, {idAttribute: 'contentItemId'});
export const paperAssessmentListSchema = new Schema.Array(paperAssessmentListEntity);
